import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { spaceFeaturesQueryOptions } from 'data/spaces';
import { type RoutePath, useLocalSearchParams } from 'expo-router';
import { getIsInSidebar } from 'platform-specific/url';
import { SkeletonConversationScreen } from 'structure/question/loading-screen';
import { SkeletonStandaloneConversationScreen } from 'structure/question/standalone-loading-screen';
import { questionModuleQuery } from 'system/structure-modules';

export const unstable_settings = {
    initialRouteName: 'index',
};

export function SuspenseFallback() {
    return <QuestionLoadingScreen />;
}

export default function QuestionInstancePublicLayout() {
    const { siloKey, instanceKey } = useLocalSearchParams<Extract<RoutePath, `/[siloKey]/question/[instanceKey]${string}`>>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'question',
        instanceKey,
        featuresSource: spaceFeaturesQueryOptions,
        moduleQuery: questionModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}

function QuestionLoadingScreen() {
    if (getIsInSidebar()) {
        return <SkeletonConversationScreen />;
    }

    return <SkeletonStandaloneConversationScreen />;
}
